/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Use_Original_TimingInputs */

const en_use_original_timing = /** @type {(inputs: Use_Original_TimingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use Original Timing`)
};

const fr_use_original_timing = /** @type {(inputs: Use_Original_TimingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utiliser le minutage original`)
};

const de_use_original_timing = /** @type {(inputs: Use_Original_TimingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Originale Zündung verwenden`)
};

const it_use_original_timing = /** @type {(inputs: Use_Original_TimingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usa la temporizzazione originale`)
};

const ru_use_original_timing = /** @type {(inputs: Use_Original_TimingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Использовать исходное время`)
};

const es_use_original_timing = /** @type {(inputs: Use_Original_TimingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utilice la sincronización original`)
};

const zh_cn2_use_original_timing = /** @type {(inputs: Use_Original_TimingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`使用原时序`)
};

const ja_use_original_timing = /** @type {(inputs: Use_Original_TimingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`オリジナルのタイミングを使用する`)
};

const hi_use_original_timing = /** @type {(inputs: Use_Original_TimingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मूल समय का उपयोग करें`)
};

const pt_pt2_use_original_timing = /** @type {(inputs: Use_Original_TimingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use a sincronização original`)
};

/**
* | output |
* | --- |
* | "Use Original Timing" |
*
* @param {Use_Original_TimingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const use_original_timing = /** @type {((inputs?: Use_Original_TimingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Use_Original_TimingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_use_original_timing(inputs)
	if (locale === "de") return de_use_original_timing(inputs)
	if (locale === "it") return it_use_original_timing(inputs)
	if (locale === "ru") return ru_use_original_timing(inputs)
	if (locale === "es") return es_use_original_timing(inputs)
	if (locale === "zh-CN") return zh_cn2_use_original_timing(inputs)
	if (locale === "ja") return ja_use_original_timing(inputs)
	if (locale === "hi") return hi_use_original_timing(inputs)
	if (locale === "pt-PT") return pt_pt2_use_original_timing(inputs)
	return en_use_original_timing(inputs)
});